// extracted by mini-css-extract-plugin
export default {"titulo":"Aplicativos_titulo__CNNOd","container":"Aplicativos_container__3jyiV","ponto":"Aplicativos_ponto__uIIcn"};